export {default as fuseDark} from './fuseDark';